


































import { Vue, Component, Watch } from 'vue-property-decorator';
import { namespace, State, Action } from 'vuex-class';
import VoteList from './components/VoteList.vue';
import * as config from './config';
import { BottomTabbar } from '@/components';
import { countDown, getLocalTime } from './util';
import { baseInfo } from './api';
const Modules = namespace('CQZM2020');
@Component({
  name: 'GiveLike',
  components: {
    VoteList,
    BottomTabbar,
  },
})
export default class GiveLike extends Vue {
  @Modules.Action fetchBalance!: () => void;
  @Modules.Action fetchUserInfo!: () => void;
  options = config.OPTHINES;
  tabActiveVal = 0;
  listType = 1;
  timeStr: any = '00天00时00秒';
  beginOrEnd: string = '开始';
  startTime: string = '';
  endTime: string = '';
  created() {
    this.fetchBalance();
    this.fetchUserInfo();
    baseInfo().then((res: any) => {
      this.startTime = getLocalTime(res.data.startTime);
      this.endTime = getLocalTime(res.data.endTime);
      this.nowInDate();
      this.$addPv(res.data.activityId);
    });
  }
  // 活动计时
  nowInDate() {
    if (countDown(this.startTime)) {
      this.beginOrEnd = '开始';
      setInterval(() => {
        this.timeStr = countDown(this.startTime);
      }, 1000);
    } else if (countDown(this.endTime)) {
      this.beginOrEnd = '结束';
      setInterval(() => {
        this.timeStr = countDown(this.endTime);
      }, 1000);
    } else {
      this.beginOrEnd = '结束';
      this.timeStr = '00天00时00秒';
    }
  }

  handleClickTab(index: number, type: number) {
    this.tabActiveVal = index;
    this.listType = type;
  }
  handleClickToDetail(param: any) {
    const type =
      this.tabActiveVal === 0 || this.tabActiveVal === 1
        ? this.tabActiveVal + 1
        : this.listType;
    this.$router.push({
      path: '/20200909CQZM/detail',
      query: {
        type: type.toString(),
        id: param,
      },
    });
  }
}
